import { request, COMPANY_ID } from './apiClient';

//const API_BASE_URL = process.env.REACT_APP_VDR_URL || 'http://localhost:8080/api';
//const COMPANY_ID2 = process.env.REACT_APP_COMPANY_ID || '';

export const validateUser = async (email: string) => {
  const url = `/company/${COMPANY_ID}/users/validate?email=${encodeURIComponent(email)}`;
  console.log(`[validateUser] Calling: ${url}`);
  return await request(url, { withAuth: false });
};

export const getAllCompanyUsers = async () => {
  const url = `/company/${COMPANY_ID}/users`;
  console.log(`[getAllUsers] Calling: ${url}`);
  return await request(url);
};

export const getUser = async (email: string, companyId: string) => {
  const url = `/company/${COMPANY_ID}/users/user?email=${encodeURIComponent(email)}&companyId=${encodeURIComponent(companyId)}`;
  console.log(`[getUser] Calling: ${url}`);
  return await request(url);
};

export const createUser = async (
  userName: string,
  userSurname: string,
  userCompany: string,
  userEmail: string,
  companyId: string,
  userLanguage: string,
  notification: boolean
) => {
  const url = `/company/${COMPANY_ID}/users/user?notification=${encodeURIComponent(notification)}`;
  console.log(`[createUser] Calling: ${url} with userEmail=${userEmail}`);
  return await request(url, {
    method: 'POST',
    body: JSON.stringify({ userName, userSurname, userCompany, userEmail, companyId, userLanguage }),
  });
};

export const assignAccessUser = async (
  userEmail: string,
  companyId: string,
  accessType: string
) => {
  const url = `/company/${COMPANY_ID}/users/access`;
  console.log(`[assignAccessUser] Calling: ${url} with userEmail=${userEmail}`);
  return await request(url, {
    method: 'POST',
    body: JSON.stringify({ userEmail, companyId, accessType }),
  });
};

export const getAccessUser = async (userId: string, companyId: string) => {
  const url = `/company/${COMPANY_ID}/users/access?userId=${encodeURIComponent(userId)}&companyId=${encodeURIComponent(companyId)}`;
  console.log(`[getAccessUser] Calling: ${url} with userId=${userId}`);
  return await request(url); 
};

export const deleteUser = async (userEmail: string, companyId: string) => {
  const url = `/company/${companyId}/users/user?userEmail=${encodeURIComponent(userEmail)}&companyId=${encodeURIComponent(companyId)}`;
  console.log(`[deleteUser] Calling: ${url}`);
  await request(url, { method: 'DELETE' });
  return true;
};

export const updateUserStatus = async (
  userEmail: string,
  userStatus: string,
  companyId: string
) => {
  const url = `/company/${COMPANY_ID}/users/update/status`;
  console.log(`[updateUserStatus] Calling: ${url} with userEmail=${userEmail}`);
  return await request(url, {
    method: 'PUT',
    body: JSON.stringify({ userEmail, userStatus, companyId }),
  }); 
};

export const notificationUser = async (
  userName: string,
  recipientEmail: string
) => {
  const url = `/company/${COMPANY_ID}/users/user/notification`;
  console.log(`[assignAccessUser] Calling: ${url} with userEmail=${recipientEmail}`);
  return await request(url, {
    method: 'POST',
    body: JSON.stringify({ userName, recipientEmail }),
  });
};

export const sessionLogin = async (
) => {
  const url = `/session/login`;
  console.log(`[sessionLogin] Calling: ${url}`);
  return await request(url, {
    method: 'POST',
  });
};

